import {
  STRIPE_URL,
  SET_USER,
  SET_STRIPLE_TOKEN,
  SET_STRIPE_CLIENTSECRET,
  SET_STRIPE_CUSTOMERSESSION_CLIENTSECRET,
} from './const';
import app from '../base';
import axios from 'axios';
import history from '../history';
import Routes from '../routes';
import {useEffect, useState} from "react";
import {setAuctionServerUpdate, setDealsServerUpdate, setRaffleServerUpdate} from '../actions/products';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment/moment.js'

const axiosStipe = axios.create({
    baseURL: STRIPE_URL,
    timeout: 10000,
    headers: {'Content-type':'application/json'}
});

const isDevelopment = process.env.NODE_ENV === 'development';
const target = isDevelopment ? 'stripeDev' : 'stripe';

export const setUser = (user) => {
  return {
    type: SET_USER,
    payload: user
  }
};

 /*axiosStipe.interceptors.response.use(null, error => {
    const expectedError = 
    error.response &&
    error.response >= 400 &&
    error.response < 500;

    if(!expectedError){
        //console.log('Logging the error', error);
        /*toast.error("An unexpected error occured!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
            })*/
  /*  }

    return Promise.reject(error)
});*/

export const createCheckoutSessionInitialize = (amount, quantity, productDescription) => {
  return (dispatch, getState)  => {

    const state = getState();
    const {login} = state;
    //const [clientSecret, setClientSecret] = useState();

    const userRef = app.database().ref(`/users/${login.user.phoneNumber}/stripe/customerID`);
    let customerId = ''
        userRef.once('value', (snapshot) => {
          if (!snapshot.val()) {
              createCustomerNew();
            } else {
              customerId = snapshot.val();
            


    const bodyData = new FormData();

        bodyData.append("amount", amount);
        bodyData.append("quantity", '1');
        bodyData.append("phone", app.auth().currentUser.phoneNumber);
        bodyData.append("productDescription", productDescription);
        bodyData.append("customerID",customerId);
        console.log("createCheckoutSessionInitialize");

        //console.log("SID", paymentMethod);

        /*      await fetch(
                  'https://staging-pn-stripe.herokuapp.com/createCustomer',
                  {
                      mode: 'no-cors', // no-cors
                      method: "POST",
                      body: bodyData,
                      headers: {
                          "Content-type":"text/html",
                      }
                  }
              )*/
        axiosStipe.post('/payment_intent', bodyData)
            .then((res) => {
                const {data} = res;
                if (res.status === 200) {

                    //let id = data['associated_objects'][0].id;
                    //let clientSecret = data['client_secret'];
                    let clientSecretHere = data['clientSecret'];
                    let customerSessionClientSecret = data['sessionClientSecret'];
                    //setClientSecret(clientSecretHere);
                    console.log('----IDCS', customerSessionClientSecret);
    
                    dispatch(setStripeClientSecret(clientSecretHere));
                    dispatch(setStripePaymentSessionFB(clientSecretHere));
                    dispatch(setStripeCustomerSessionClientSecret(customerSessionClientSecret));
                    dispatch(setStripeCustomerSessionFB(customerSessionClientSecret));


                    //dispatch(attachpaymentMethod(paymentMethod, customerId, save, () => {history.push(Routes.bidReceived)}));

                    //dispatch(saveCustomer(customerId));
                }

            })
            .catch((error) => {
                console.log('Client Secret Error', error);
            });
          }
        });

    }
};

const setStripePaymentSessionFB = (clientSecret, callback) => {
  return (dispatch, getState) => {

    const state = getState();

    const {login} = state;

     const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/session`);

    let timeNow = moment().format('YYYY-MM-DD HH:mm:ss ZZ')

 let sessionStripeConfig = {
      //...product,
      clientSecret: clientSecret,
      setTime: timeNow,
      endTime: moment(timeNow).add(7,'days').format('YYYY-MM-DD HH:mm:ss ZZ') 
    };

     userRef.set(sessionStripeConfig);
     /*userRef.once('value', (snapshot) => {
          const lastKey = snapshot.node_.children_.root_.maxKey();
          //const lastKey = snapshot.node_.root_.maxKey(); */
     /* if (snapshot.val()) {
         const lastKey = snapshot.node_.children_.root_.maxKey();

          userRef.child(`${lastKey}/paymentMethod`).set(token);
      }*/

      //productRef.child(`/${childInx}`).set(productConfig, (error) => {callback(error, lastCount + 1)});
     /* userRef.ref('/session').set(sessionStripeConfig);
      //userRef.child(`${lastKey}`).set(sessionStripeConfig);
    });*/
  }
};

const setStripeCustomerSessionFB = (clientSecret, callback) => {
  return (dispatch, getState) => {

    const state = getState();

    const {login} = state;

     const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/cust_session`);

    let timeNow = moment().format('YYYY-MM-DD HH:mm:ss ZZ')

 let sessionStripeConfig = {
      //...product,
      clientSecret: clientSecret,
      setTime: timeNow,
      endTime: moment(timeNow).add(7,'days').format('YYYY-MM-DD HH:mm:ss ZZ') 
    };

     userRef.set(sessionStripeConfig);
     /*userRef.once('value', (snapshot) => {
          const lastKey = snapshot.node_.children_.root_.maxKey();
          //const lastKey = snapshot.node_.root_.maxKey(); */
     /* if (snapshot.val()) {
         const lastKey = snapshot.node_.children_.root_.maxKey();

          userRef.child(`${lastKey}/paymentMethod`).set(token);
      }*/

      //productRef.child(`/${childInx}`).set(productConfig, (error) => {callback(error, lastCount + 1)});
     /* userRef.ref('/session').set(sessionStripeConfig);
      //userRef.child(`${lastKey}`).set(sessionStripeConfig);
    });*/
  }
};




export const createPaymentIntent = (customer, type, id , quantity) => {
  return (dispatch, getState, clientSecret)  => {
    console.log('HERE IS THE ID In Action',id);
    const state = getState();
    const {login} = state;
    //const [clientSecret, setClientSecret] = useState();
    const userRef = app.database().ref(`/users/${login.user.phoneNumber}/stripe/customerID`);
    
        userRef.once('value', (snapshot) => {
          let customerId = ''
          /*if (!snapshot.val()) {
              createCustomerNew();
            } else {
              customerId = snapshot.val();
            }*/
          if(snapshot.val()){
            customerId = snapshot.val();
          }

    const bodyData = new FormData();

        bodyData.append("type", type);
        bodyData.append("id", id);
        bodyData.append("quantity", quantity);
        bodyData.append("phone", app.auth().currentUser.phoneNumber);
        bodyData.append("customer_id",customerId);
        //bodyData.append("productDescription", productDescription);


        //console.log("SID", paymentMethod);

        /*      await fetch(
                  'https://staging-pn-stripe.herokuapp.com/createCustomer',
                  {
                      mode: 'no-cors', // no-cors
                      method: "POST",
                      body: bodyData,
                      headers: {
                          "Content-type":"text/html",
                      }
                  }
              )*/
        axiosStipe.post('/payment_intent', bodyData)
            .then((res) => {
                const {data} = res;
                if (res.status === 200) {

                    //let id = data['associated_objects'][0].id;
                    //let clientSecret = data['client_secret'];
                    let clientSecretHere = data['clientSecret'];
                    let customerSessionClientSecret = data['sessionClientSecret'];
                    //setClientSecret(clientSecretHere);
                    console.log('----ID', clientSecretHere);
    
                    dispatch(setStripeClientSecret(clientSecretHere));
                    dispatch(setStripePaymentSessionFB(clientSecretHere)); //take out later
                    dispatch(setStripeCustomerSessionClientSecret(customerSessionClientSecret));
                    dispatch(setStripeCustomerSessionFB(customerSessionClientSecret));

                    history.push(Routes.stripleCheckout);

                    
                    //dispatch(attachpaymentMethod(paymentMethod, customerId, save, () => {history.push(Routes.bidReceived)}));

                    //dispatch(saveCustomer(customerId));
                }

            })
            .catch((error) => {
                console.log('Client Secret Error', error);
                
            });
         });
    }
};

export const createSetupIntent = (customer, type, id) => {
  return (dispatch, getState, clientSecret)  => {
    console.log('HERE IS THE ID In Action',id);
    const state = getState();
    const {login} = state;
    //const [clientSecret, setClientSecret] = useState();
    const userRef = app.database().ref(`/users/${login.user.phoneNumber}/stripe/customerID`);
    
        userRef.once('value', (snapshot) => {
          let customerId = ''
          if(snapshot.val()){
            customerId = snapshot.val();
          }

    const bodyData = new FormData();

        bodyData.append("type", 'Bids');
        bodyData.append("id", id);
        bodyData.append("phone", app.auth().currentUser.phoneNumber);
        bodyData.append("customer_id",customerId);

        axiosStipe.post('/setup_intent', bodyData)
            .then((res) => {
                const {data} = res;
                if (res.status === 200) {

              
                    let clientSecretHere = data['clientSecret'];
                    let customerSessionClientSecret = data['sessionClientSecret'];
              
                    console.log('----ID', clientSecretHere);
                     const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/cards`);

                        //console.log('fff', paymentMethod);

                        const stripleTokenRef = userRef.child(clientSecretHere);

                        //console.log("111", paymentMethod);

                       /* stripleTokenRef.set(clientSecretHere, () => {
                            dispatch(setStripleToken(clientSecretHere)); //Changed here
                        });*/
                    dispatch(setStripleToken(clientSecretHere));    
                    dispatch(setStripeClientSecret(clientSecretHere));
                    dispatch(setStripePaymentSessionFB(clientSecretHere)); //take out later
                    dispatch(setStripeCustomerSessionClientSecret(customerSessionClientSecret));
                    dispatch(setStripeCustomerSessionFB(customerSessionClientSecret));

                    history.push(Routes.stripleCheckout);

                    
                    //dispatch(attachpaymentMethod(paymentMethod, customerId, save, () => {history.push(Routes.bidReceived)}));

                    //dispatch(saveCustomer(customerId));
                }

            })
            .catch((error) => {
                console.log('Client Secret Error', error);
                
            });
         });
    }
};

export const payProduct = (amount, paymentMethod, type, save = false, isSavedCard = false, id, quantity) => {
  return (dispatch, getState) => {

    const state = getState();

    const {login} = state;

    const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/customerID`);

    const isCharged = false;

    sessionStorage[`auctionWin-${id}`] = sessionStorage[`auctionWin-${id}`] == null ? 0 : sessionStorage[`auctionWin-${id}`];
    //sessionStorage 1 = needs to be charged, 2 = charged, 0 = default state

    /*const productRef = app.database().ref(`Purchased_Products/Auction/${id}`);
        productRef.once('value', (snapshot) => {
        if (snapshot.val()) {
          const lastKey = snapshot.node_.children_.root_.maxKey();
         isCharged = productRef.child(`/${lastKey}/charged`) ? true : false; 
    
   

    console.log("IDs: ", id);
    //if(type === "auction" && 

  
    if(type === "auction" && sessionStorage[`auctionWin-${id}`] == 2 && isCharged){
      console.log("SUCCESS 100", sessionStorage[`auctionWin-${id}`]);
    } else {
      console.log("SUCCESS 2",sessionStorage[`auctionWin-${id}`]);
    }
          }
  });*/
    if(type === "auction"){
      console.log("Dispatching setAuctionServerUpdate: ", id);
       console.log("Dispatching setAuctionServerUpdate bid amount: ", sessionStorage[`auction-${id}`]);
      dispatch(setAuctionServerUpdate(id,sessionStorage[`auction-${id}`]));
       console.log("Dispatched setAuctionServerUpdate continue");
    }
 console.log("PAYPRODUCT QUANTITY", quantity);
    //console.log('---', amount);
//if time expired and auction then charge or change type to auctionwin or add another prop for auctionwin 
    userRef.once("value", (snapshot) => {
      if (snapshot.val()) {
          console.log("PAYPRODUCT continue: ", type);
          if (isSavedCard) {
              (type === "auction" &&  sessionStorage[`auctionWin-${id}`] == 0) 
              ? history.push(Routes.bidReceived)
              : dispatch(createCharge(amount, paymentMethod, snapshot.val(), false, save, type, id, quantity));
          } else {
              (type === "auction" && sessionStorage[`auctionWin-${id}`] == 0) 
              ? dispatch(attachpaymentMethod(paymentMethod, snapshot.val(), save, () => {history.push(Routes.bidReceived)}))
              : dispatch(createChargeAndAttach(amount, paymentMethod, snapshot.val(), false, save , type, id, quantity));
          }
      } else {
          (type === "auction" && sessionStorage[`auctionWin-${id}`] == 0) 
          ? dispatch(createCustomerToAuction(amount, paymentMethod, save))
          : dispatch(createCustomerAndCharge(amount, paymentMethod, save, type, id, quantity));
      }
      /*if(sessionStorage[`auctionWin-${id}`] == 1){
        history.push(`${Routes.productReceivedPage}/${'purchase'}/${type}/${id}`);
      }*/
    });


  }
};

export const createCustomerToAuction = (amount, paymentMethod, save = false) => {
    return async (dispatch) => {

        const bodyData = new FormData();

        bodyData.append("paymentMethod", paymentMethod.id);
        bodyData.append("phone", app.auth().currentUser.phoneNumber);

        console.log("SID", paymentMethod);

        /*      await fetch(
                  'https://staging-pn-stripe.herokuapp.com/createCustomer',
                  {
                      mode: 'no-cors', // no-cors
                      method: "POST",
                      body: bodyData,
                      headers: {
                          "Content-type":"text/html",
                      }
                  }
              )*/
        axiosStipe.post('/createCustomer', bodyData)
            .then((res) => {
                const {data} = res;
                if (res.status === 200) {

                    //let id = data['associated_objects'][0].id;
                    let customerId = data['customerid'];
                    //console.log('--ID', data);

                    dispatch(attachpaymentMethod(paymentMethod, customerId, save, () => {history.push(Routes.bidReceived)}));

                    dispatch(saveCustomer(customerId));
                }

            })
            .catch((error) => {
                console.log('AuctionError', error);
            });
    }
};

export const createCustomerAndSetup = (type, id) => {
  return async (dispatch) => {
    const bodyData = new FormData();

    bodyData.append("name", app.auth().currentUser.name);
    bodyData.append("phone", app.auth().currentUser.phoneNumber);

    axiosStipe.post('/createCustomer', bodyData)
      .then(({data}) => {
 
        let customerId = data['customerid'];
        console.log('Stripe Customer--ID', data);
        dispatch(saveCustomer(customerId));
        dispatch(createSetupIntent(customerId, 'Bids', id));
      })
      .catch((error) => {
        console.log('ephError', error);
      });
  }
};


export const createCustomerNew = () => {
  return async (dispatch) => {
    const bodyData = new FormData();

    bodyData.append("name", app.auth().currentUser.name);
    bodyData.append("phone", app.auth().currentUser.phoneNumber);


    axiosStipe.post('/createCustomerNew', bodyData)
      .then(({data}) => {
          let customerId = data['customerid'];
        console.log('Stripe Customer--ID', data);

              //dispatch(attachpaymentMethod(paymentMethod, customerId, save));
        dispatch(saveCustomer(customerId));
      })
      .catch((error) => {
        console.log('ephError', error);
      });
  }
};


export const createCustomerAndCharge = (type, id, quantity) => {
  return async (dispatch) => {
    const bodyData = new FormData();

    bodyData.append("name", app.auth().currentUser.name);
    bodyData.append("phone", app.auth().currentUser.phoneNumber);

    axiosStipe.post('/createCustomer', bodyData)
      .then(({data}) => {
 
        let customerId = data['customerid'];
        console.log('Stripe Customer--ID', data);
        dispatch(saveCustomer(customerId));
        dispatch(createPaymentIntent(customerId, type, id, quantity));
      })
      .catch((error) => {
        console.log('ephError', error);
      });
  }
};

/*export const createCustomerAndChargeOld = (type, id, quantity) => {
  return async (dispatch) => {
    const bodyData = new FormData();

      bodyData.append("paymentMethod", paymentMethod.id);
      bodyData.append("phone", app.auth().currentUser.phoneNumber);

    axiosStipe.post('/createCustomer', bodyData)
      .then(({data}) => {

          const userRef = app.database().ref(`/users/${login.user.phoneNumber}/stripe/customerID`);
    let customerId = ''
        userRef.once('value', (snapshot) => {
          if (!snapshot.val()) {
              createCustomerNew();
            } else {
              customerId = snapshot.val();
            }
 
          let customerId = data['customerid'];
        console.log('Stripe Customer--ID', data);

              //dispatch(attachpaymentMethod(paymentMethod, customerId, save));
        //ADD BACK IN WILL 
        dispatch(saveCustomer(customerId));
        dispatch(createCharge(amount, paymentMethod, customerId, true, save, type, id, quantity));
      })
      .catch((error) => {
        console.log('ephError', error);
      });
    }
  }
};*/

export const createCharge = (amount, paymentMethod, customer, newCustomer = false, save = false, type, id, quantity) => {
  return async (dispatch, getState) => {
    const bodyData = new FormData();

    bodyData.append('amount', amount);
    bodyData.append('paymentMethod', paymentMethod.id);
    bodyData.append('customer_id', customer);



/*      await fetch(
          'https://staging-pn-stripe.herokuapp.com/chargeCustomer',
          {
              mode: 'no-cors', // no-cors
              method: "POST",
              body: bodyData,
              headers: {
                  "Content-type":"text/html",
              }
          }
      )*/
    axiosStipe.post('/chargeCustomer', bodyData)
        .then((res) => {
            if (res.status === 200) {
                //console.log('rrr', res);

                if (newCustomer) {
                    dispatch(saveCustomer(customer));
                }

                     if(type === "deals"){
                        //console.log("DISPATCH SERVER UPDATE HERE DEALID: ", id);
                        dispatch(setDealsServerUpdate(id, quantity));
                      }
                     if(type === "raffle"){
                      // console.log("DISPATCH SERVER UPDATE HERE RAFFLEID: ", id);
                      // console.log("DISPATCH SERVER UPDATE HERE RAFFLE Quantity: ", quantity);
                        dispatch(setRaffleServerUpdate(id, quantity));
                     }




                   if (sessionStorage[`auctionWin-${id}`] == 1 && type === "auction") {
                            const productRef = app.database().ref(`Purchased_Products/Auction/${id}`);
                            productRef.once('value', (snapshot) => {
                                if (snapshot.val()) {
                                const lastKey = snapshot.node_.children_.root_.maxKey();
                                const stateRef= productRef.child(`/${lastKey}/state`);
                                stateRef.set("charged");  
                                productRef.child(`${lastKey}/charged`).set(true);
                                }
                            });
                      sessionStorage[`auctionWin-${id}`] = 2;
                      //dispatch(setAuctionServerUpdate(id,sessionStorage[`auction-${id}`])); 
                       history.push(Routes.bidReceived);
                      //dispatch(setAuctionWinCharged(id));
                      //dispatch(setOffer('auction', id, elem.bidMax));
                      //dispatch(fetchAuctionList());
                     
                      //history.push(`${Routes.productReceivedPage}/${'purchase'}/${type}/${id}`); 
                    } else { 
                      //dispatch(setAuctionServerUpdate(id,sessionStorage[`auction-${id}`]));
                      history.push(Routes.bidReceived);
                  }

                

            }
        })
        .catch((error) => {
            console.log('ChargeError', error);
            setTimeout(() => { history.replace(`${Routes.productPage}/${type}/${id}`);
            }, 3500);
          toast.error("Could not complete payment, try again!", {
            // Set to 5sec
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
          });

        });
  }
};

export const createChargeAndAttach = (amount, paymentMethod, customer, newCustomer = false, save = false, type, id, quantity) => {
    return (dispatch, getState) => {
        const bodyData = new FormData();

        bodyData.append('amount', amount);
        bodyData.append('paymentMethod', paymentMethod.id);
        bodyData.append('customer_id', customer);
      


        dispatch(attachpaymentMethod(paymentMethod, customer, save, async () => {
/*            await fetch(
                'https://staging-pn-stripe.herokuapp.com/chargeCustomer',
                {
                    mode: 'no-cors', // no-cors
                    method: "POST",
                    body: bodyData,
                    headers: {
                        "Content-type":"text/html",
                    }
                }
            )*/


            axiosStipe.post('/chargeCustomer', bodyData)
                .then( async (res) => {
                    if (res.status === 200) {
                        //console.log('rrr', res);

                        if (newCustomer) {
                          dispatch(saveCustomer(customer));
                        }

                            if(type === "deals"){
                              // console.log("DISPATCH SERVER UPDATE HERE DEALID: ", id);
                              dispatch(setDealsServerUpdate(id, quantity));
                            }
                            if(type === "raffle"){
                               //console.log("DISPATCH SERVER UPDATE HERE RAFFLEID: ", id);
                               //console.log("DISPATCH SERVER UPDATE HERE RAFFLEID Quantity: ", quantity);
                              dispatch(setRaffleServerUpdate(id, quantity));
                            } 

                      

                        if (sessionStorage[`auctionWin-${id}`] == 1 && type === "auction"){
                            
                            const productRef = app.database().ref(`Purchased_Products/Auction/${id}`);
                            productRef.once('value', (snapshot) => {
                                if (snapshot.val()) {
                                const lastKey = snapshot.node_.children_.root_.maxKey();
                                const stateRef= productRef.child(`/${lastKey}/state`);
                                stateRef.set("charged"); 

                                productRef.child(`${lastKey}/charged`).set(true);
                                  
                                }
                             });
                            sessionStorage[`auctionWin-${id}`] = 2; 
                            history.push(Routes.bidReceived);
                            //dispatch(setAuctionServerUpdate(id,sessionStorage[`auction-${id}`]));
                            //dispatch(setOffer('auction', id, elem.bidMax));
                            //dispatch(fetchAuctionList());
                            //history.push(Routes.bidReceived);
                            //history.push(`${Routes.productReceivedPage}/${'purchase'}/${type}/${id}`); 
                          } else { 
                            //dispatch(setAuctionServerUpdate(id,sessionStorage[`auction-${id}`]));
                            //dispatch(setOffer(type, id, quantity));
                            history.push(Routes.bidReceived);
                        }
                       
                    }
                })
                .catch((error) => {
                    console.log('ChargeError', error);
                    //add popup error
                    setTimeout(() => {
                        history.replace(`${Routes.productPage}/${type}/${id}`);
                    }, 3500);
                    toast.error("Could not complete payment, try again!", {
                          // Set to 3sec
                          position: toast.POSITION.TOP_RIGHT,
                          autoClose: 3000,
                      });
                });
        }));




    }
};

export const saveCustomer = (customer) => {
  return (dispatch, getState) => {
      const state = getState();

      const {login} = state;

      const customerRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/customerID`);

      customerRef.set(customer);

/*    const bodyData = new FormData();

    bodyData.append('api_version', '2015-10-12');
    bodyData.append('customer_id', customer);

    axios.post('/ephemeral_keys', bodyData)
      .then((res) => {
        const state = getState();

        const {login} = state;

        const customerRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/customerID`);

        customerRef.set(customer);
      })
      .catch((error) => {
        console.log('saveError', error);
      });*/
  }
};

export const setStripleToken = (token) => {
  return {
    type: SET_STRIPLE_TOKEN,
    payload: token
  }
};

export const setStripeClientSecret= (clientSecret) => {
  return {
    type: SET_STRIPE_CLIENTSECRET,
    payload: clientSecret
  }
};

export const setStripeCustomerSessionClientSecret = (customerSessionClientSecret) => {
  return {
    type: SET_STRIPE_CUSTOMERSESSION_CLIENTSECRET,
    payload: customerSessionClientSecret
  }
};



export const fetchSignOut = () => {
  return (dispatch) => {

    if (sessionStorage.stripleToken) {
      delete sessionStorage.stripleToken;
    }

        app
          .auth()
          .signOut()
          .catch((error) => {
            alert(error);
          })
    }
};

export const saveStriplePaymentMethod = (paymentMethod, customer) => {
  return (dispatch, getState) => {

      const state = getState();

      const {login} = state;

      const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/cards`);

      attachpaymentMethod(paymentMethod, customer, () => {
          const striplePaymentMethodRef = userRef.child(paymentMethod.id);

          //console.log("111", paymentMethod);

          striplePaymentMethodRef.set(paymentMethod, () => {
              //dispatch(setStripleToken(paymentMethod));
          });
      });
      //console.log('fff', paymentMethod);
  }
};

export const attachpaymentMethod = (paymentMethod, customer, save = false, callback) => {
    return async (dispatch, getState) => {
        const bodyData = new FormData();

        bodyData.append("phone", app.auth().currentUser.phoneNumber);
        bodyData.append('paymentMethod', paymentMethod);
        bodyData.append('customer_id', customer);

/*        await fetch(
            'https://staging-pn-stripe.herokuapp.com/attachpaymentMethod',
            {
                mode: 'no-cors', // no-cors
                method: "POST",
                body: bodyData,
                headers: {
                    "Content-type":"text/html",
                }
            }
        )*/
        axiosStipe.post('/attachpaymentMethod', bodyData)
            .then(async (res) => {
                if (res.status === 200) {
                    //console.log('attach', res);

                    if (save) {
                        const state = getState();

                        const {login} = state;

                        const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/cards`);

                        //console.log('fff', paymentMethod);

                        const stripleTokenRef = userRef.child(paymentMethod);

                        //console.log("111", paymentMethod);

                        stripleTokenRef.set(paymentMethod, () => {
                            dispatch(setStripleToken(paymentMethod)); //Changed here
                        });
                    }

                    if (callback) {
                        callback();
                    }
                }
            })
            .catch((error) => {
                console.log('attachError', error);
            });
    }
};



export const fetchSavedCards = () => {
  return (dispatch, getState) => {
    const state = getState();

    const {login} = state;

    const userRef = app.database().ref(`/users/${login.user.phoneNumber}/${target}/cards`);

    userRef.once('value', (snapshot) => {
      if (snapshot.val()) {
        dispatch(setStripleToken(snapshot.val()));
      }
    })
  }
};

export const saveStripleTokenToProduct = (customerID, token, type, id) => {
  return (dispatch, getState) => {
    const state = getState();
    const {login} = state;

    console.log('ffffU', token, type);

    const userRef = app.database().ref(`/Purchased_Products/${getTypePath[type]}/${id}`);

/*    const stripleTokenRef = userRef.child(token.id);

    stripleTokenRef.set(token, () => {
      dispatch(setStripleToken(token));
    });*/

    userRef.once('value', (snapshot) => {
        if (snapshot.val()) {
           const lastItemIDArray = []
           snapshot.forEach((bidSnapShot) => {
             console.log('fffU PhoneNumber bidsnapShot', bidSnapShot.child(`phoneNumber`).val() , login.user.phoneNumber);
            if (bidSnapShot.child(`phoneNumber`).val() == login.user.phoneNumber){
              const itemID = bidSnapShot.child(`itemId`).val() //parseInt(bidSnapShot.child(`itemId`).val(),10);
              lastItemIDArray.push(itemID);
              console.log("ITEMID: ",itemID);

     
              }
           })

            if (lastItemIDArray.length != 0) {
              const lastItemID = Math.max(...lastItemIDArray);
              userRef.child(`${lastItemID}/paymentMethod`).set(token);

              if (type === "auction") {
                  userRef.child(`${lastItemID}/charged`).set(false);
              }

              userRef.child(`${lastItemID}/customerID`).set(customerID);
            }
          /*const lastKey = snapshot.node_.children_.root_.maxKey();

          userRef.child(`${lastKey}/paymentMethod`).set(token);

          if (type === "auction") {
              userRef.child(`${lastKey}/charged`).set(false);
          }

          userRef.child(`${lastKey}/customerID`).set(customerID);*/
        }
    });
  }
};


export const saveStripleToken = (token, type, id) => {
  return (dispatch, getState) => {
    const state = getState();

    console.log('ffffU', token, type);

    const userRef = app.database().ref(`/Purchased_Products/${getTypePath[type]}/${id}`);

/*    const stripleTokenRef = userRef.child(token.id);

    stripleTokenRef.set(token, () => {
      dispatch(setStripleToken(token));
    });*/

    userRef.once('value', (snapshot) => {
        if (snapshot.val()) {
          const lastKey = snapshot.node_.children_.root_.maxKey();

          userRef.child(`${lastKey}/paymentMethod`).set(token);

          if (type === "auction") {
              userRef.child(`${lastKey}/charged`).set(false);
          }
        }
    });
  }
};

const getTypePath = {
  'raffle': 'Raffle',
  'auction': 'Auction',
  'deals': 'Deals'
};